export const weekTypes = {
    next: 'next',
    firstInMonth: 'first-in-month',
    lastInMonth: 'last-in-month',
};
export default weekTypes;
